module.exports = __webpack_public_path__ + "static/media/twitter.bff336dd.svg";